"use strict"; // Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/getPrototypeOf");

require("core-js/modules/es6.object.define-property");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var widgets_1 = require("@phosphor/widgets");
/**
 * A phosphor widget which wraps an IFrame.
 */


var IFrame = /*#__PURE__*/function (_widgets_1$Widget) {
  _inherits(IFrame, _widgets_1$Widget);

  var _super = _createSuper(IFrame);

  /**
   * Create a new IFrame widget.
   */
  function IFrame() {
    var _this;

    _classCallCheck(this, IFrame);

    _this = _super.call(this, {
      node: Private.createNode()
    });

    _this.addClass('jp-IFrame');

    return _this;
  }
  /**
   * The url of the IFrame.
   */


  _createClass(IFrame, [{
    key: "url",
    get: function get() {
      return this.node.querySelector('iframe').getAttribute('src') || '';
    },
    set: function set(url) {
      this.node.querySelector('iframe').setAttribute('src', url);
    }
  }]);

  return IFrame;
}(widgets_1.Widget);

exports.IFrame = IFrame;
/**
 * A namespace for private data.
 */

var Private;

(function (Private) {
  /**
   * Create the main content node of an iframe widget.
   */
  function createNode() {
    var node = document.createElement('div');
    var iframe = document.createElement('iframe');
    iframe.style.height = '100%';
    iframe.style.width = '100%';
    node.appendChild(iframe);
    return node;
  }

  Private.createNode = createNode;
})(Private || (Private = {}));